import React, { memo, useContext } from 'react';

import { AppContext } from 'App';

import './DiscoverHow.scss';

const DiscoverHow = () => {
  const { pageData } = useContext(AppContext);
  const { title, img_url, paragraph } = pageData?.discovery;

  return (
    <section id="discoverSection" className="discover_how">
      <div className="container">
        <div className="conten_box">
          <div className="content_area">
            <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
            {paragraph?.map((itemContent, index) => (
              <p key={index}>{itemContent}</p>
            ))}
          </div>
          <div className="image_sec">
            <img src={img_url} alt="dedicated Internet connection" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(DiscoverHow);
